<div class="stage-container">
  <div class="stage-content">
    <div class="stage-image">
      <img [src]="imageSrc" [alt]="imageAlt" />
    </div>

    <div class="stage-text">
      <h1>{{ title }}</h1>
      <p class="copy">{{ subtitle }}</p>
    </div>
  </div>
</div>
